import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth, startGoogleLogin } from "../../context/AuthContext";
import { BagLogo, BagLogoTile } from "../../components/Logo";
import { toast } from "sonner";

const ROLE_LABEL = { STAFF: "Osoblje", MANAGER: "Menadžer", OWNER: "Vlasnik" };

export default function InviteAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/team/invite/${token}`).then(({ data }) => setInvite(data)).catch(() => setError("Pozivnica nije pronađena ili je istekla."));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/team/invite/${token}/accept`); toast.success("Pristup dodeljen"); navigate(`/restaurant/${data.restaurant_id}/orders`, { replace: true }); }
    catch (e) { toast.error(e?.response?.data?.detail || "Greška"); setBusy(false); }
  };

  if (error) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 p-6 text-center"><BagLogo size={56} /><p className="font-display font-bold">{error}</p><a href="/" className="text-brand-red underline">Nazad na Ponesi</a></div>
  );
  if (!invite || loading) return <div className="min-h-screen flex items-center justify-center bg-white"><div className="animate-pop"><BagLogoTile size={88} /></div></div>;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 p-6 bg-[#F3F4F6]" data-testid="invite-accept">
      <BagLogo size={64} />
      <div className="bg-white rounded-2xl border p-6 max-w-sm w-full text-center">
        <h1 className="font-display font-black text-2xl">Pozivnica za tim</h1>
        <p className="text-slate-500 mt-2">Pozvani ste u <b>{invite.restaurant_name}</b> kao <b>{ROLE_LABEL[invite.role] || invite.role}</b>.</p>
        <p className="text-xs text-slate-400 mt-1">Za: {invite.email}</p>
        {!user ? (
          <button data-testid="invite-login" onClick={() => startGoogleLogin(`/team/invite/${token}`)} className="mt-5 w-full bg-brand-red hover:bg-brand-redHover text-white rounded-full py-3 font-bold">Prijavi se da prihvatiš</button>
        ) : user.email?.toLowerCase() !== invite.email?.toLowerCase() ? (
          <p className="mt-5 text-sm text-brand-red">Prijavljeni ste kao {user.email}, a pozivnica je za {invite.email}. Odjavite se i prijavite ispravnim nalogom.</p>
        ) : (
          <button data-testid="invite-accept-btn" disabled={busy} onClick={accept} className="mt-5 w-full bg-brand-red hover:bg-brand-redHover text-white rounded-full py-3 font-bold disabled:opacity-60">{busy ? "Prihvatanje..." : "Prihvati pozivnicu"}</button>
        )}
      </div>
    </div>
  );
}
